import firebase from 'firebase'
// import 'firebase/firestore'

const apiKey = process.env.REACT_APP_API_KEY
const authDomain = process.env.REACT_APP_AUTH_DOMAIN
const databaseURL = process.env.REACT_APP_DATABASE_URL
const projectId = process.env.REACT_APP_PROJECT_ID
const storageBucket = process.env.REACT_APP_STORAGE_BUCKET


// Initialize Firebase
  var config = {
    apiKey: apiKey,
    authDomain: authDomain,
    databaseURL: databaseURL,
    projectId: projectId,
    storageBucket: storageBucket
  }


  const firebaseApp = firebase.initializeApp(config)

  // remove firebase firestore warning about date changes
  // firebaseApp.firestore().settings( { timestampsInSnapshots: true })

  //const fireStore = firebaseApp.firestore()
  const authenticate = (email,password) => {
    return firebaseApp.auth().signInAndRetrieveDataWithEmailAndPassword(email, password)
  }

  // const checkAdmin = new Promise((resolve,reject) => {
  //   console.log('CHECKING ADMIN IN APP');
  //   var res = {
  //     status: null,
  //     message: null
  //   }
  //   firebaseApp.database().ref('admin').once('value')
  //   .then(snapshot => {
  //     // console.log('snapshot',snapshot);
  //     var admin = snapshot.val();
  //     res.status = "OK";
  //     res.message = admin;
  //     return resolve(res);
  //   })
  //   .catch(err => {
  //     // console.log('err',err);
  //     res.status = "ERROR";
  //     res.message = err;
  //     return reject(res);
  //   })
  // })

  const signOut = () => {
    return firebaseApp.auth().signOut()
  }


export {
  firebaseApp,
  // fireStore,
  // checkAdmin,
  authenticate,
  signOut
}



// WEBPACK FOOTER //
// ./src/firebase.js